unit Essentials.Web.CustomNames.EditValueForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Essentials.Web.BaseEditForm, Data.DB, WEBLib.DB,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.DBCtrls,
  Essentials.Web.Shared;

type
  TCustomNamesEditValue = class(TEssentialsBaseEditForm)
    CustomNamesEdit: TDBEdit;
    EntitySelector: TDBLookupComboBox;
    FieldSelector: TDBLookupComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure CustomNamesEditExit(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject; const ASelectFirstField: Boolean = True);
    procedure FieldSelectorChange(Sender: TObject);
    procedure EditButtonClick(Sender: TObject);
  private
    { Private declarations }
    function AllRequiredFieldsAreSet: Boolean; override;
    procedure SetEditMode(const Value: TEditMode); override;
  public
    procedure LoadEntityList(const ASelectDefaults: Boolean = True);
    procedure SyncSelectorsFromDataset;
  protected procedure LoadDFMValues; override; end;

var
  CustomNamesEditValue: TCustomNamesEditValue;

implementation

uses Essentials.Web.Manager, Essentials.Shared,
Generics.Collections, SMX.Web.Utils, XData.Web.Dataset;

{$R *.dfm}

function TCustomNamesEditValue.AllRequiredFieldsAreSet: Boolean;
begin
  Result := (EntitySelector.ItemIndex > -1) and (FieldSelector.ItemIndex > -1) and
    (Trim(CustomNamesEdit.Text) <> '');
end;

procedure TCustomNamesEditValue.CustomNamesEditExit(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TCustomNamesEditValue.EntitySelectorChange(Sender: TObject; const ASelectFirstField: Boolean);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

  lFields := EssentialsManager.CustomNamesManager.RegisteredFields[selectedValue];

  if Assigned(lFields) then
  begin
    for fld in lFields do
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
  end;

  if ASelectFirstField and (FieldSelector.LookupValues.Count > 0) then
    FieldSelector.ItemIndex := 0;

  UpdateState;
end;

procedure TCustomNamesEditValue.EditButtonClick(Sender: TObject);
begin
  if (FEditMode <> None) and (DataSource.DataSet.State in [dsInsert, dsEdit]) then
  begin
    DataSource.DataSet.FieldByName('EntityClassName').AsString := EntitySelector.Value;
    DataSource.DataSet.FieldByName('FieldName').AsString := FieldSelector.Value;
    DataSource.DataSet.FieldByName('CustomName').AsString := Trim(CustomNamesEdit.Text);
  end;
  inherited;
end;

procedure TCustomNamesEditValue.FieldSelectorChange(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TCustomNamesEditValue.LoadEntityList(const ASelectDefaults: Boolean);
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
  lDataset: TXDataWebDataset;
  lData: TJSObject;
begin
  EntitySelector.LookupValues.Clear;
  for lDef in EssentialsManager.CustomNamesManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
    begin
      lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);
      EntitySelector.LookupValues.AddPair(lName, lCustom);
    end;
  end;

  if EntitySelector.LookupValues.Count > 0 then
  begin
    if ASelectDefaults then
    begin
      EntitySelector.ItemIndex := 0;
      EntitySelectorChange(EntitySelector);
      if DataSource.DataSet.State in [dsInsert, dsEdit] then
      begin
        DataSource.DataSet.FieldByName('EntityClassName').AsString := EntitySelector.Value;
        if FieldSelector.ItemIndex > -1 then
          DataSource.DataSet.FieldByName('FieldName').AsString := FieldSelector.Value;
        DataSource.DataSet.FieldByName('CustomName').Clear;
        if DataSource.DataSet is TXDataWebDataset then
        begin
          lDataset := TXDataWebDataset(DataSource.DataSet);
          if Assigned(lDataset.CurrentData) then
          begin
            lData := TJSObject(lDataset.CurrentData);
            lData['EntityClassName'] := EntitySelector.Value;
            if FieldSelector.ItemIndex > -1 then
              lData['FieldName'] := FieldSelector.Value
            else
              lData['FieldName'] := '';
            lData['CustomName'] := '';
          end;
        end;
      end;
    end
    else
      SyncSelectorsFromDataset;
  end;
end;

procedure TCustomNamesEditValue.SyncSelectorsFromDataset;
var
  lEntity, lField: string;
  i: Integer;
begin
  lEntity := DataSource.DataSet.FieldByName('EntityClassName').AsString;
  lField := DataSource.DataSet.FieldByName('FieldName').AsString;

  EntitySelector.ItemIndex := -1;
  for i := 0 to EntitySelector.LookupValues.Count - 1 do
  begin
    EntitySelector.ItemIndex := i;
    if SameText(EntitySelector.Value, lEntity) then
      Break;
  end;

  EntitySelectorChange(EntitySelector, False);

  FieldSelector.ItemIndex := -1;
  for i := 0 to FieldSelector.LookupValues.Count - 1 do
  begin
    FieldSelector.ItemIndex := i;
    if SameText(FieldSelector.Value, lField) then
      Break;
  end;
end;

procedure TCustomNamesEditValue.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    EntitySelector.Enabled := FEditMode = Add;
    FieldSelector.Enabled := FEditMode = Add;
    CustomNamesEdit.Enabled := True;
    CustomNamesEdit.SetFocus;
  end;
end;

procedure TCustomNamesEditValue.WebFormCreate(Sender: TObject);
begin
  inherited;
  ApplyFormSelectClass(EntitySelector);
  ApplyFormSelectClass(FieldSelector);
  EntitySelector.Enabled := False;
  FieldSelector.Enabled := False;
  CustomNamesEdit.Enabled := False;
end;


procedure TCustomNamesEditValue.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CustomNamesEdit := TDBEdit.Create('essentials.customnames.customname.edit');
  EntitySelector := TDBLookupComboBox.Create('essentials.customnames.entity.selector');
  FieldSelector := TDBLookupComboBox.Create('essentials.customnames.field.selector');

  TitleBarLabel.BeforeLoadDFMValues;
  CustomNamesEdit.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  EditButton.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 100;
    TitleBarLabel.Caption := 'Edit Custom Name';
    CustomNamesEdit.SetParentComponent(Self);
    CustomNamesEdit.Name := 'CustomNamesEdit';
    CustomNamesEdit.Left := 375;
    CustomNamesEdit.Top := 113;
    CustomNamesEdit.Width := 242;
    CustomNamesEdit.Height := 22;
    CustomNamesEdit.ChildOrder := 4;
    CustomNamesEdit.ElementClassName := 'form-control';
    CustomNamesEdit.ElementFont := efCSS;
    CustomNamesEdit.ElementPosition := epIgnore;
    CustomNamesEdit.HeightStyle := ssAuto;
    CustomNamesEdit.HeightPercent := 100.000000000000000000;
    CustomNamesEdit.Text := 'CustomNamesEdit';
    CustomNamesEdit.WidthStyle := ssAuto;
    CustomNamesEdit.WidthPercent := 100.000000000000000000;
    CustomNamesEdit.DataField := 'CustomName';
    CustomNamesEdit.DataSource := DataSource;
    SetEvent(CustomNamesEdit, Self, 'OnExit', 'CustomNamesEditExit');
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 62;
    EntitySelector.Top := 113;
    EntitySelector.Width := 145;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'form-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.DataField := 'EntityClassName';
    EntitySelector.DataSource := DataSource;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 216;
    FieldSelector.Top := 113;
    FieldSelector.Width := 145;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'form-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    SetEvent(FieldSelector, Self, 'OnChange', 'FieldSelectorChange');
    FieldSelector.DataField := 'FieldName';
    FieldSelector.DataSource := DataSource;
    SetEvent(EditButton, Self, 'OnClick', 'EditButtonClick');
  finally
    TitleBarLabel.AfterLoadDFMValues;
    CustomNamesEdit.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
    EditButton.AfterLoadDFMValues;
  end;
end;

end.